import type { OperatorRow } from '../domain/types'

const CLOCK_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/

export function isOverdueRow(row: OperatorRow): boolean {
  return !!(row.t.isOverdue || row.t.scheduleState === 'Expired')
}

export function isWaitingForCall(row: OperatorRow): boolean {
  return row.t.status === 'Checked'
}

export function isScheduledRow(row: OperatorRow): boolean {
  return row.t.status === 'Opened' || row.t.status === 'Authorized' || row.t.status === 'Reopened'
}

export function callableRows(work: { eligible: OperatorRow[]; blocked: OperatorRow[] }, singleDay: boolean): OperatorRow[] {
  const eligible = work.eligible.filter(isWaitingForCall)
  if (!singleDay) {return eligible}
  return [...eligible, ...work.blocked.filter((r) => isOverdueRow(r) && isWaitingForCall(r))]
}
export function pickPreferential(rows: OperatorRow[]): OperatorRow | undefined {
  return rows.filter((r) => r.a.prioridade > 0)
    .sort((x, y) => y.a.prioridade - x.a.prioridade || (x.a._createdAtMs ?? 0) - (y.a._createdAtMs ?? 0))[0]
}

function formatClock(value?: string): string {
  if (!value) {return ''}
  const clock = value.match(CLOCK_PATTERN)
  if (clock) {return `${clock[1]}:${clock[2]}`}

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {return ''}

  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Maceio',
  })
}

export function formatSessionRange(start?: string, end?: string): string {
  const startLabel = formatClock(start)
  const endLabel = formatClock(end)
  return startLabel && endLabel ? `${startLabel}–${endLabel}` : ''
}
